import PropTypes from 'prop-types'

const TextCell = ({ title, text }) => {
  return (
    <div className="text-cell">
      <span>{title}</span>
      <span>{text}</span>
    </div>
  )
}

TextCell.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
}

export default TextCell
